module.exports = __webpack_public_path__ + "static/media/sonicboom_location_map@2x.33773d36.png";